import React from 'react'
import FormControlLabel from '@material-ui/core/FormControlLabel'
import Radio from '@material-ui/core/Radio'
import Icon from '@material-ui/core/Icon';
import classNames from 'classnames';

class StyledRadio extends React.PureComponent {
  render() {
    const {color, className, error, ...other} = this.props
    const newClass = error ? classNames('radio_with_errors', className) : className
    return (
      <FormControlLabel
        className={newClass}
        control={
          <Radio
            checkedIcon={<Icon>check_circle</Icon>}
            color={color || "default"}

          />
        }
        {...other}
      />
    )
  }
}

export default StyledRadio



// WEBPACK FOOTER //
// ./src/js/components/inputs/StyledRadio.js